import { CircularProgress, Grid } from '@mui/material';
import classNames from 'classnames';
import { CSSProperties } from 'react';

type LoaderProps = {
  my?: number; // margin y
  mt?: number; // margin top
  mb?: number; // margin bottom,
  size?: number;
  justify?: 'center' | 'flex-start' | 'flex-end';
  className?: string;
  spinnerStyle?: CSSProperties;
  style?: CSSProperties;
};

const Loader = (props?: LoaderProps) => {
  const { mt, mb, size, justify, className, spinnerStyle, style } = props;

  // Default margin Y
  let { my } = props;

  my = my !== undefined ? my : 4;

  // Style
  const iconStyle: CSSProperties = {};

  if (size) {
    iconStyle.width = size;
    iconStyle.height = size;
  }

  return (
    <Grid
      container
      justifyContent={justify || 'center'}
      className={classNames(
        {
          [`my-${my}`]: my || my === 0,
          [`mt-${mt}`]: mt || mt === 0,
          [`mb-${mb}`]: mb || mb === 0,
        },
        className,
      )}
      style={{ ...(style || {}) }}
    >
      <CircularProgress
        disableShrink
        style={{
          ...iconStyle,
          ...(spinnerStyle || {}),
        }}
      />
    </Grid>
  );
};

export default Loader;
